/**
 * Auto-generated from ChatUI.css — do not edit directly.
 * Exported as a string so ChatUI can inject it without bundler ?inline support.
 */
export const CHAT_CSS = `
/**
 * @geepers/chat — default UI styles
 * Self-contained: injected as a <style> tag when ChatUI mounts.
 * Uses CSS custom properties so host page can override any token.
 */

/* ========== Reset & Scope ========== */
.gchat-root,
.gchat-root * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* ========== Tokens ========== */
.gchat-root {
  /* Light theme defaults */
  --gchat-bg-0:     #ffffff;
  --gchat-bg-1:     #f4f4f5;
  --gchat-bg-2:     #e4e4e7;
  --gchat-text-0:   #18181b;
  --gchat-text-1:   #3f3f46;
  --gchat-text-2:   #71717a;
  --gchat-border:   #d4d4d8;
  --gchat-accent:   #6366f1;
  --gchat-accent-h: #4f46e5;
  --gchat-error:    #ef4444;
  --gchat-radius:   8px;
  --gchat-radius-sm:4px;
  --gchat-shadow:   0 1px 3px rgba(0,0,0,0.08);
  --gchat-font:     -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --gchat-mono:     'SFMono-Regular', Consolas, 'Liberation Mono', monospace;
  --gchat-ease:     150ms ease;
  --gchat-sidebar-w:260px;
}

/* Dark theme override */
.gchat-root[data-theme="dark"] {
  --gchat-bg-0:   #09090b;
  --gchat-bg-1:   #18181b;
  --gchat-bg-2:   #27272a;
  --gchat-text-0: #fafafa;
  --gchat-text-1: #d4d4d8;
  --gchat-text-2: #71717a;
  --gchat-border: #3f3f46;
  --gchat-shadow: 0 1px 3px rgba(0,0,0,0.4);
}

/* ========== Root Layout ========== */
.gchat-root {
  font-family: var(--gchat-font);
  font-size: 14px;
  color: var(--gchat-text-0);
  background: var(--gchat-bg-0);
  display: flex;
  height: 100%;
  min-height: 400px;
  overflow: hidden;
  position: relative;
}

/* ========== Sidebar ========== */
.gchat-sidebar {
  width: var(--gchat-sidebar-w);
  flex-shrink: 0;
  background: var(--gchat-bg-1);
  border-right: 1px solid var(--gchat-border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.gchat-sidebar-header {
  padding: 12px 14px;
  border-bottom: 1px solid var(--gchat-border);
  display: flex;
  align-items: center;
  gap: 8px;
}

.gchat-sidebar-title {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--gchat-text-2);
  flex: 1;
}

.gchat-new-btn {
  padding: 5px 10px;
  background: var(--gchat-accent);
  color: #fff;
  border: none;
  border-radius: var(--gchat-radius-sm);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--gchat-ease);
  white-space: nowrap;
}
.gchat-new-btn:hover { background: var(--gchat-accent-h); }

.gchat-history {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.gchat-history-empty {
  padding: 16px;
  font-size: 0.8rem;
  color: var(--gchat-text-2);
  text-align: center;
}

.gchat-history-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 10px;
  border-radius: var(--gchat-radius-sm);
  cursor: pointer;
  transition: background var(--gchat-ease);
}
.gchat-history-item:hover { background: var(--gchat-bg-2); }
.gchat-history-item.active {
  background: var(--gchat-accent);
  color: #fff;
}

.gchat-history-item-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.82rem;
}

.gchat-history-item-del {
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.4;
  font-size: 0.75rem;
  padding: 2px 4px;
  border-radius: 2px;
  transition: opacity var(--gchat-ease);
  flex-shrink: 0;
}
.gchat-history-item-del:hover { opacity: 1; }

/* ========== Main Area ========== */
.gchat-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--gchat-bg-0);
}

/* ========== Top bar ========== */
.gchat-topbar {
  padding: 10px 14px;
  border-bottom: 1px solid var(--gchat-border);
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.gchat-mobile-toggle {
  display: none;
  background: none;
  border: 1px solid var(--gchat-border);
  border-radius: var(--gchat-radius-sm);
  padding: 5px 8px;
  cursor: pointer;
  color: var(--gchat-text-0);
  font-size: 0.85rem;
}

.gchat-provider-select {
  padding: 5px 8px;
  border: 1px solid var(--gchat-border);
  border-radius: var(--gchat-radius-sm);
  background: var(--gchat-bg-0);
  color: var(--gchat-text-0);
  font-size: 0.82rem;
  cursor: pointer;
}

.gchat-topbar-spacer { flex: 1; }

.gchat-provider-badge {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--gchat-accent);
  white-space: nowrap;
}

/* System prompt toggle */
.gchat-sys-toggle {
  background: none;
  border: 1px solid var(--gchat-border);
  border-radius: var(--gchat-radius-sm);
  padding: 4px 8px;
  font-size: 0.75rem;
  cursor: pointer;
  color: var(--gchat-text-2);
  transition: all var(--gchat-ease);
}
.gchat-sys-toggle:hover { color: var(--gchat-text-0); border-color: var(--gchat-accent); }

/* System prompt panel */
.gchat-sysprompt-panel {
  padding: 8px 14px;
  border-bottom: 1px solid var(--gchat-border);
  background: var(--gchat-bg-1);
}
.gchat-sysprompt-panel.hidden { display: none; }

.gchat-sysprompt-input {
  width: 100%;
  padding: 7px 10px;
  border: 1px solid var(--gchat-border);
  border-radius: var(--gchat-radius-sm);
  background: var(--gchat-bg-0);
  color: var(--gchat-text-0);
  font-family: var(--gchat-font);
  font-size: 0.82rem;
  resize: vertical;
  min-height: 60px;
}
.gchat-sysprompt-input:focus {
  outline: none;
  border-color: var(--gchat-accent);
}

/* ========== Messages ========== */
.gchat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px 14px;
  scroll-behavior: smooth;
}

/* Welcome screen */
.gchat-welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 24px;
  height: 100%;
  min-height: 200px;
}

.gchat-welcome h2 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 8px;
}

.gchat-welcome p {
  color: var(--gchat-text-2);
  margin-bottom: 20px;
  font-size: 0.9rem;
}

.gchat-hints {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.gchat-hint-chip {
  padding: 7px 14px;
  border: 1px solid var(--gchat-border);
  border-radius: 20px;
  background: var(--gchat-bg-1);
  color: var(--gchat-text-1);
  font-size: 0.82rem;
  cursor: pointer;
  transition: all var(--gchat-ease);
}
.gchat-hint-chip:hover {
  border-color: var(--gchat-accent);
  color: var(--gchat-accent);
  background: var(--gchat-bg-0);
}

/* Message bubbles */
.gchat-msg {
  margin-bottom: 16px;
  max-width: 100%;
}

.gchat-msg-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.gchat-msg-role {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--gchat-text-2);
}

.gchat-msg-actions {
  display: flex;
  gap: 4px;
  margin-left: auto;
  opacity: 0;
  transition: opacity var(--gchat-ease);
}
.gchat-msg:hover .gchat-msg-actions { opacity: 1; }

.gchat-msg-action-btn {
  background: none;
  border: 1px solid var(--gchat-border);
  border-radius: var(--gchat-radius-sm);
  padding: 2px 7px;
  font-size: 0.72rem;
  cursor: pointer;
  color: var(--gchat-text-2);
  transition: all var(--gchat-ease);
}
.gchat-msg-action-btn:hover { color: var(--gchat-text-0); border-color: var(--gchat-accent); }

.gchat-msg-body {
  line-height: 1.65;
  word-break: break-word;
}

.gchat-msg.user .gchat-msg-body {
  white-space: pre-wrap;
}

/* Loading animation */
.gchat-msg.loading .gchat-msg-body::after {
  content: '▋';
  display: inline-block;
  animation: gchat-blink 1s step-end infinite;
  color: var(--gchat-accent);
  margin-left: 2px;
}

@keyframes gchat-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

/* Error message */
.gchat-msg.error .gchat-msg-body {
  color: var(--gchat-error);
  font-style: italic;
}

/* Markdown content */
.gchat-msg-body p { margin-bottom: 0.75em; }
.gchat-msg-body p:last-child { margin-bottom: 0; }
.gchat-msg-body ul, .gchat-msg-body ol { padding-left: 1.4em; margin-bottom: 0.75em; }
.gchat-msg-body li { margin-bottom: 0.25em; }
.gchat-msg-body h1, .gchat-msg-body h2, .gchat-msg-body h3 {
  margin: 1em 0 0.4em;
  font-weight: 700;
}
.gchat-msg-body h1 { font-size: 1.2em; }
.gchat-msg-body h2 { font-size: 1.1em; }
.gchat-msg-body h3 { font-size: 1em; }
.gchat-msg-body code {
  font-family: var(--gchat-mono);
  font-size: 0.88em;
  background: var(--gchat-bg-2);
  padding: 0.15em 0.35em;
  border-radius: 3px;
}
.gchat-msg-body pre {
  background: var(--gchat-bg-2);
  border: 1px solid var(--gchat-border);
  border-radius: var(--gchat-radius-sm);
  padding: 12px 14px;
  overflow-x: auto;
  margin-bottom: 0.75em;
  position: relative;
}
.gchat-msg-body pre code {
  background: none;
  padding: 0;
  font-size: 0.85em;
}
.gchat-msg-body blockquote {
  border-left: 3px solid var(--gchat-accent);
  padding-left: 12px;
  color: var(--gchat-text-2);
  margin: 0.5em 0;
}
.gchat-msg-body a { color: var(--gchat-accent); text-decoration: underline; }
.gchat-msg-body table { border-collapse: collapse; margin-bottom: 0.75em; width: 100%; }
.gchat-msg-body th, .gchat-msg-body td {
  border: 1px solid var(--gchat-border);
  padding: 6px 10px;
  font-size: 0.85em;
}
.gchat-msg-body th { background: var(--gchat-bg-1); font-weight: 600; }

/* Code block copy button */
.gchat-code-copy {
  position: absolute;
  top: 6px;
  right: 8px;
  padding: 2px 7px;
  font-size: 0.72rem;
  background: var(--gchat-bg-1);
  border: 1px solid var(--gchat-border);
  border-radius: 3px;
  cursor: pointer;
  color: var(--gchat-text-2);
  transition: all var(--gchat-ease);
  opacity: 0;
}
.gchat-msg-body pre:hover .gchat-code-copy { opacity: 1; }
.gchat-code-copy:hover { color: var(--gchat-text-0); }

/* ========== Input Bar ========== */
.gchat-input-bar {
  padding: 12px 14px;
  border-top: 1px solid var(--gchat-border);
  background: var(--gchat-bg-0);
  flex-shrink: 0;
}

.gchat-input-row {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

.gchat-textarea {
  flex: 1;
  padding: 9px 12px;
  border: 1px solid var(--gchat-border);
  border-radius: var(--gchat-radius);
  background: var(--gchat-bg-1);
  color: var(--gchat-text-0);
  font-family: var(--gchat-font);
  font-size: 0.9rem;
  line-height: 1.5;
  resize: none;
  min-height: 44px;
  max-height: 200px;
  overflow-y: auto;
  transition: border-color var(--gchat-ease);
}
.gchat-textarea:focus {
  outline: none;
  border-color: var(--gchat-accent);
}
.gchat-textarea::placeholder { color: var(--gchat-text-2); }

.gchat-send-btn,
.gchat-stop-btn {
  padding: 9px 16px;
  border: none;
  border-radius: var(--gchat-radius);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--gchat-ease);
  white-space: nowrap;
  flex-shrink: 0;
  height: 44px;
}

.gchat-send-btn {
  background: var(--gchat-accent);
  color: #fff;
}
.gchat-send-btn:hover:not(:disabled) { background: var(--gchat-accent-h); }
.gchat-send-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.gchat-stop-btn {
  background: var(--gchat-bg-2);
  color: var(--gchat-text-0);
  border: 1px solid var(--gchat-border);
}
.gchat-stop-btn:hover { background: var(--gchat-error); color: #fff; border-color: var(--gchat-error); }
.gchat-stop-btn.hidden { display: none; }

/* ========== Sidebar overlay (mobile) ========== */
.gchat-overlay {
  display: none;
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 10;
}
.gchat-overlay.visible { display: block; }

/* ========== Toast ========== */
.gchat-toast {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  background: var(--gchat-text-0);
  color: var(--gchat-bg-0);
  padding: 8px 16px;
  border-radius: var(--gchat-radius);
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 200ms, transform 200ms;
  z-index: 100;
}
.gchat-toast.show {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

/* ========== Mobile ========== */
@media (max-width: 640px) {
  .gchat-sidebar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 20;
    transform: translateX(-100%);
    transition: transform 200ms ease;
  }
  .gchat-sidebar.open {
    transform: translateX(0);
  }
  .gchat-mobile-toggle { display: block; }
}
`;
